
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {Level2Quotes} from '../core/Level2Quotes';
import {FieldModelLevel2Quotes} from '../core/Level2Quotes';

/**
 * FeedUpdateLevel2SnapshotResponse struct
 */
class FeedUpdateLevel2SnapshotResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!Date=} time
   * @param {!Map=} level2
   * @constructor
   */
  constructor (parent = new Response(), time = new Date(0), level2 = new Map()) {
    super()
    super.copy(parent)
    this.Time = time
    this.Level2 = level2
  }

  /**
   * Copy struct (shallow copy)
   * @this {!FeedUpdateLevel2SnapshotResponse}
   * @param {!FeedUpdateLevel2SnapshotResponse} other Other struct
   * @returns {!FeedUpdateLevel2SnapshotResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Time != null) {
      if (other.Time instanceof Date) {
        this.Time = new Date(other.Time.getTime())
      } else {
        this.Time = new Date(Math.round(other.Time / 1000000))
      }
    } else {
      this.Time = null
    }
    if (other.Level2 != null) {
      this.Level2 = new Map()
      Object.keys(other.Level2).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = key
          if (other.Level2[key] != null) {
            let tempValue
            tempValue = Level2Quotes.fromObject(other.Level2[key])
            this.Level2.set(tempKey, tempValue)
          } else {
            this.Level2.set(tempKey, null)
          }
        }
      })
    } else {
      this.Level2 = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!FeedUpdateLevel2SnapshotResponse}
   * @returns {!FeedUpdateLevel2SnapshotResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new FeedUpdateLevel2SnapshotResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new FeedUpdateLevel2SnapshotResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!FeedUpdateLevel2SnapshotResponse}
   * @param {!FeedUpdateLevel2SnapshotResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof FeedUpdateLevel2SnapshotResponse)) {
      throw new TypeError('Instance of FeedUpdateLevel2SnapshotResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!FeedUpdateLevel2SnapshotResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Time: ((this.Time != null) ? (this.Time.getTime() * 1000000) : null),
      Level2: ((this.Level2 != null) ? fbe.MapToObject(new Map(Array.from(this.Level2, item => [((item[0] != null) ? item[0] : null), ((item[1] != null) ? item[1] : null)]))) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return FeedUpdateLevel2SnapshotResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!FeedUpdateLevel2SnapshotResponse} other Object value
   * @returns {!FeedUpdateLevel2SnapshotResponse} Created struct
   */
  static fromObject (other) {
    return new FeedUpdateLevel2SnapshotResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!FeedUpdateLevel2SnapshotResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return FeedUpdateLevel2SnapshotResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!FeedUpdateLevel2SnapshotResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6353
  }
}

export { FeedUpdateLevel2SnapshotResponse };

/**
 * Fast Binary Encoding FeedUpdateLevel2SnapshotResponse field model
 */
class FieldModelFeedUpdateLevel2SnapshotResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.Time = new fbe.FieldModelTimestamp(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.Level2 = new fbe.FieldModelMap(new fbe.FieldModelString(buffer, this.Time.fbeOffset + this.Time.fbeSize), new FieldModelLevel2Quotes(buffer, this.Time.fbeOffset + this.Time.fbeSize), buffer, this.Time.fbeOffset + this.Time.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Time.fbeSize + this.Level2.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Time.fbeExtra + this.Level2.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelFeedUpdateLevel2SnapshotResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6353
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Time.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Time.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Time.fbeSize

    if ((fbeCurrentSize + this.Level2.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Level2.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Level2.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @param {!FeedUpdateLevel2SnapshotResponse} fbeValue Default value, defaults is new FeedUpdateLevel2SnapshotResponse()
   * @returns {!FeedUpdateLevel2SnapshotResponse} FeedUpdateLevel2SnapshotResponse value
   */
  get (fbeValue = new FeedUpdateLevel2SnapshotResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @param {!FeedUpdateLevel2SnapshotResponse} fbeValue FeedUpdateLevel2SnapshotResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Time.fbeSize) <= fbeStructSize) {
      fbeValue.Time = this.Time.get()
    } else {
      fbeValue.Time = new Date(0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Time.fbeSize

    if ((fbeCurrentSize + this.Level2.fbeSize) <= fbeStructSize) {
      this.Level2.get(fbeValue.Level2)
    } else {
      fbeValue.Level2.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Level2.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @param {!FeedUpdateLevel2SnapshotResponse} fbeValue FeedUpdateLevel2SnapshotResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelFeedUpdateLevel2SnapshotResponse}
   * @param {FeedUpdateLevel2SnapshotResponse} fbeValue FeedUpdateLevel2SnapshotResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Time.set(fbeValue.Time)
    this.Level2.set(fbeValue.Level2)
  }
}

export { FieldModelFeedUpdateLevel2SnapshotResponse };

/**
 * Fast Binary Encoding FeedUpdateLevel2SnapshotResponse model
 */
class FeedUpdateLevel2SnapshotResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelFeedUpdateLevel2SnapshotResponse(this.buffer, 4)
  }

  /**
   * Get the FeedUpdateLevel2SnapshotResponse model
   * @this {!FeedUpdateLevel2SnapshotResponseModel}
   * @returns {!FieldModelFeedUpdateLevel2SnapshotResponse} model FeedUpdateLevel2SnapshotResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!FeedUpdateLevel2SnapshotResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!FeedUpdateLevel2SnapshotResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return FeedUpdateLevel2SnapshotResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!FeedUpdateLevel2SnapshotResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelFeedUpdateLevel2SnapshotResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!FeedUpdateLevel2SnapshotResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!FeedUpdateLevel2SnapshotResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!FeedUpdateLevel2SnapshotResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!FeedUpdateLevel2SnapshotResponseModel}
   * @param {!FeedUpdateLevel2SnapshotResponse} value FeedUpdateLevel2SnapshotResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!FeedUpdateLevel2SnapshotResponseModel}
   * @param {!FeedUpdateLevel2SnapshotResponse} value FeedUpdateLevel2SnapshotResponse value, defaults is new FeedUpdateLevel2SnapshotResponse()
   * @return {!object} Deserialized FeedUpdateLevel2SnapshotResponse value and its size
   */
  deserialize (value = new FeedUpdateLevel2SnapshotResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new FeedUpdateLevel2SnapshotResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new FeedUpdateLevel2SnapshotResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!FeedUpdateLevel2SnapshotResponseModel}
   * @param {!number} prev Previous FeedUpdateLevel2SnapshotResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { FeedUpdateLevel2SnapshotResponseModel };
